import { render, staticRenderFns } from "./Bankaccount.vue?vue&type=template&id=5001ec90&"
import script from "./Bankaccount.vue?vue&type=script&lang=js&"
export * from "./Bankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports